import * as React from 'react';
export const IcGardenPlants = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M21 12a2.5 2.5 0 00-2.5-2.5H18l.32-.33a2.5 2.5 0 00-3.53-3.53L14.5 6v-.5a2.5 2.5 0 00-5 0V6l-.33-.32a2.5 2.5 0 00-3.53 3.49L6 9.5h-.5a2.5 2.5 0 000 5H6l-.32.33a2.5 2.5 0 003.53 3.53L9.5 18v.46a2.5 2.5 0 005 0V18l.33.32a2.5 2.5 0 003.53-3.53L18 14.5h.46A2.5 2.5 0 0021 12zm-9 3a3 3 0 110-5.999A3 3 0 0112 15z'
      fill='currentColor'
    />
  </svg>
);
